module.exports = __webpack_public_path__ + "img/COO-Darojat-Yogi-Candra-new.fd3f9129.jpg";